export default __webpack_public_path__ + "static/media/Ellipse43.3f56cd42.svg";